import { useState, useCallback } from 'react';
import VetrinaService from '../services/VetrinaService/VetrinaService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useVetrina = () => {
    const [loading, setLoading] = useState(false);

    const getVetrina = useCallback(async () => {
        setLoading(true);
        try {
            const response = await VetrinaService.getVetrina();
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    const getPromozioni = useCallback(async (id_classi_superpartner) => {
        setLoading(true);
        try {
            const response = await VetrinaService.getPromozioni({ id_classi_superpartner });
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    const createPromozione = useCallback(async (data) => {
        setLoading(true);
        try {
            await VetrinaService.createPromozione(data);
            alertService.success("Promozione creata con successo!", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const updatePromozione = useCallback(async (data) => {
        setLoading(true);
        try {
            await VetrinaService.updatePromozione(data);
            alertService.success("Promozione aggiornata con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const deletePromozione = useCallback(async (id_promozione) => {
        setLoading(true);
        try {
            await VetrinaService.deletePromozione({ id_promozione });
            alertService.success("Promozione eliminata con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        isLoading: loading,
        getVetrina,
        getPromozioni,
        createPromozione,
        updatePromozione,
        deletePromozione
    };
};

export default useVetrina;